/**
 * Generated by orval 🍺
 * Do not edit manually.
 * IST.Connect | v1
 * REST API backing the IST Connect web frontend. Provides endpoints to manage plugin configurations and inspect task execution results, logs, and dashboard data.
 * OpenAPI spec version: 1.0.0
 */
import type { ConfigPage, ConfigRequestResult, ConfigSummary, CreateConfigRequestParams, GetConfigsParams } from "../model";

import { customFetch } from "../../customFetcher";

export const getCreateConfigRequestUrl = (id: string, params?: CreateConfigRequestParams) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : String(value));
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/istconnect-service-api/configs/${id}/requests?${stringifiedParams}`
		: `/istconnect-service-api/configs/${id}/requests`;
};

/**
 * @summary Creates a request to execute a plugin config
 */
export const createConfigRequest = async (
	id: string,
	params?: CreateConfigRequestParams,
	options?: Parameters<typeof customFetch>[1],
): Promise<ConfigRequestResult> => {
	return customFetch<ConfigRequestResult>(getCreateConfigRequestUrl(id, params), {
		...options,
		method: "POST",
	});
};

export const getGetConfigDetailUrl = (id: string) => {
	return `/istconnect-service-api/configs/${id}`;
};

/**
 * @summary Get plugin configuration details by ID
 */
export const getConfigDetail = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ConfigSummary> => {
	return customFetch<ConfigSummary>(getGetConfigDetailUrl(id), {
		...options,
		method: "GET",
	});
};

export const getGetConfigsUrl = (params?: GetConfigsParams) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : String(value));
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0 ? `/istconnect-service-api/configs?${stringifiedParams}` : `/istconnect-service-api/configs`;
};

/**
 * @summary Get all plugin configurations for the organization
 */
export const getConfigs = async (params?: GetConfigsParams, options?: Parameters<typeof customFetch>[1]): Promise<ConfigPage> => {
	return customFetch<ConfigPage>(getGetConfigsUrl(params), {
		...options,
		method: "GET",
	});
};
